export type PrizmInputSize = 'l' | 'm' | 's';
export type PrizmInputStatus = 'default' | 'success' | 'warning' | 'danger';
export type PrizmInputPosition = 'left' | 'center';
